/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [loader, setloader] = useState(true)
  const [apps, setApps] = useState();

  // const getApps = async () => {
  //   const { response, error } = await AppService.app.superadmin_apps()

  //   if (response) {
  //     setApps(response?.data);
  //   }
  // }

  const GetAppTriggerModel = async () => {
    const { response, error } = await AppService.app_trigger_model.get()
    if (response) {
      setList(response.data)
      setloader(false)
    } else {
      setList([])
      setloader(false)
    }
  }

  const formatApps = (apps) => {
    if (!apps || apps.length === 0) return 'No Apps';
    return apps.map((item) => item?.label).join(' - ');
  };

  const onLoad = () => {
    // getApps()
    GetAppTriggerModel()
  }
  const handleDelete = async (id) => {
    const { response } = await AppService.app_trigger_model.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }
  const truncateText = (text = '', max = 100) =>
    text.length > max ? text.substring(0, max) + '…' : text;

  useEffect(onLoad, [])
  return {
    loader: loader,
    apps: apps,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Key', accessor: 'key' },
        { Header: 'Sample Response', accessor: 'sample_response' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        name: data.name,
        key: data.key,
        sample_response: truncateText(data.sample_response, 60),
        action: (
          <MDBox>
            <EditModal
              data={data}
              // apps={apps}
              handleRefresh={onLoad}
            />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
